export const GET_RULE_TEMPLATE = "V3_GET_RULE_TEMPLATE";
export const GET_RULE_TEMPLATES = "V3_GET_RULE_TEMPLATES";
export const GREATE_RULE_TEMPLATE = "V3_CREATE_RULE_TEMPLATE";
export const EDIT_RULE_TEMPLATE = "V3_EDIT_RULE_TEMPLATE";

export const REASSIGN_RULE_TEMPLATES = "V3_REASSIGN_RULE_TEMPLATES";
export const ASSIGN_RULES_TO_RULE_TEMPLATE = "V3_ASSIGN_RULES_TO_RULE_TEMPLATE";
export const UNASSIGN_RULES_FROM_RULE_TEMPLATE = "V3_UNASSIGN_RULES_FROM_RULE_TEMPLATE";

export const UPDATE_RULE_TEMPLATE_RULES = "V3_UPDATE_RULE_TEMPLATE_RULES";
export const CREATE_RULE_TEMPLATE = "V3_CREATE_RULE_TEMPLATE";
export const DELETE_RULE_TEMPLATE = "V3_DELETE_RULE_TEMPLATE";
export const ADD_RULE_IN_RULE_TEMPLATE = 'V3_ADD_RULE_IN_RULE_TEMPLATE'